import { Link } from '@mui/material';
import React, { useState } from 'react';
import DefaultDialog from '../DefaultDialog';

interface Props {
	label: string;
	message: string;
	confirmText: string;
	dropdownItem?: boolean;
	onConfirm: () => void;
	children?: React.ReactNode;
}

/**
 * A Link trigger component used for actions inside of a table.
 */
const TableActionConfirmationTrigger = (props: Props) => {
	const { label, message, confirmText, onConfirm } = props;

	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);

	const open = (event: React.MouseEvent) => {
		event.preventDefault();
		setIsOpen(true);
	};

	const onConfirmClick = () => {
		close();
		onConfirm();
	};

	return (
		<>
			<Link onClick={open}>{label}</Link>
			<DefaultDialog
				actions={[
					{ text: confirmText, onClick: onConfirmClick },
					{ text: 'Cancel', onClick: close },
				]}
				open={isOpen}
				onClose={close}
				title={message}
			>
				{props.children}
			</DefaultDialog>
		</>
	);
};

export default TableActionConfirmationTrigger;
